<div class="team-settings">
  <div class="team-settings__header">
    <h1>Team: {{ teamName }}</h1>
    <mds-icon (click)="closeDialog()" [key]="icons.CLOSE" [pathColors]="['#547080']" class="pointer"></mds-icon>
  </div>
  <mds-tab (activeTabChange)="setActiveTab($event)" [tabs]="tabs"></mds-tab>
  @switch (selectedTab) {
    @case ('Members') {
      <app-member-settings
        (close)="closeDialog()"
        (reload)="init()"
        [isEditable]="actions && actions['edit']"
        [section]="teamInfo"
        [teamName]="teamName"
        [teamRid]="teamRid"
        [userRid]="userRid"
      ></app-member-settings>
    }
    @case ('Team Settings') {
      <app-team-settings-tab
        (close)="closeDialog()"
        [epdSection]="epdSection"
        [isEditable]="actions && actions['edit']"
        [isUserTeamAdmin]="isUserTeamAdmin"
        [section]="teamSettingSection"
        [teamName]="teamName"
        [teamRid]="teamRid"
      ></app-team-settings-tab>
    }
    @case ('EPD') {
      <app-epd-settings
        (sectionChange)="updateEpdSection($event)"
        [section]="epdSection"
        [teamRid]="teamRid"
        wrapperTab="EPD"
      ></app-epd-settings>
    }
    @case ('Color Palette') {
      <app-epd-settings
        (sectionChange)="updateEpdSection($event)"
        [section]="epdThemeSection"
        [teamRid]="teamRid"
        wrapperTab="Color Palette"
      ></app-epd-settings>
    }
    @case ('SSO') {
      <app-sso-settings [teamRid]="teamRid"></app-sso-settings>
    }
    @case ('SSO Providers') {
      <app-sso-provider-settings [teamRid]="teamRid"></app-sso-provider-settings>
    }
    @case ('SCIP Legal Entity') {
      <app-scip-settings
        (reload)="loadTeamData()"
        [section]="scipSection"
        [tabData]="scipTabData"
        [teamRid]="teamRid"
      ></app-scip-settings>
    }
    @case ('Data Sources') {
      <app-data-sources-settings
        (reload)="loadTeamData()"
        [section]="dataSourcesSection"
        [teamRid]="teamRid"
      ></app-data-sources-settings>
    }
  }
</div>
